import hexToRGB from 'hex-to-rgb';
import colors from '@emartech/ui-framework-colors';

const themes = {
  morningHorizon: {
    fontFamily: '"72", "Helvetica", "Arial", sans-serif',
    fontFamilyMonospace: '"72 Mono", monospace'
  }
};

const createStyleElement = () => {
  const styleElement = document.createElement('style');
  document.head.appendChild(styleElement);

  styleElement.id = 'css-variables';

  return styleElement;
};

const generateColors = colors => {
  let content = '';

  Object.keys(colors).forEach(color => {
    if (typeof colors[color] === 'string') {
      content += `--color-${color}: ${colors[color]};`;
      content += `--color-rgb-${color}: ${hexToRGB(colors[color])};`;
    } else {
      if (colors[color].default) {
        content += `--color-${color}: ${colors[color].default};`;
        content += `--color-rgb-${color}: ${hexToRGB(colors[color].default)};`;
      } else {
        content += `--color-${color}: ${colors[color]['500']};`;
        content += `--color-rgb-${color}: ${hexToRGB(colors[color]['500'])};`;
      }

      Object.keys(colors[color]).forEach(tone => {
        content += `--color-${color}-${tone}: ${colors[color][tone]};`;
        content += `--color-rgb-${color}-${tone}: ${hexToRGB(colors[color][tone])};`;
      });
    }
  });

  return content;
};

const generateVariables = styleElement => {
  let content = ':root {';

  let paletteColorList = colors.paletteMorningHorizon;
  let namedColorsList = colors.namedColorsMorningHorizon;

  const colorTheme = localStorage.getItem('e.ui.colorTheme') || 'light';

  if (colorTheme === 'dark') {
    paletteColorList = colors.paletteDark;
    namedColorsList = colors.namedColorsDark;
  }

  const paletteColors = generateColors(paletteColorList);
  const namedColors = generateColors(namedColorsList);
  const font = `--font-family: ${themes.morningHorizon.fontFamily};`;
  const fontMono = `--font-family-mono: ${themes.morningHorizon.fontFamilyMonospace};`;

  content += paletteColors;
  content += namedColors;
  content += font;
  content += fontMono;

  styleElement.innerHTML = `${content}}`;
};

export default {
  inject() {
    const styleElement = createStyleElement();

    generateVariables(styleElement);

    this.updateColorPalette();
  },

  updateColorPalette() {
    const cssVariablesStyleElement = document.querySelector('style#css-variables');

    generateVariables(cssVariablesStyleElement);
  }
};
